<template>

    <van-form class="container" @submit="onSubmit" >

        <div class="container zx-fill-ticket-info">

            <div class="header f-s-b">
                <div class="header-item theme-color-font header-item-active">填写申请信息</div>
                <div class="header-item item-line " ></div>
                <div class="header-item ">提交成功</div>
                <div class="header-item item-line " ></div>
                <div class="header-item">面试通知</div>
                <div class="header-item item-line " ></div>
                <div class="header-item">成为志愿者</div>
            </div>

            <div class="body ">
                

                <div class="contacts-title-box f-s-b g-b-500">
                    <div class="f-c">
                        <i class="iconhebei iconshenqing theme-color-font icon-size" ></i>
                        <span>报名人信息</span>
                    </div>
                </div>

                <ul class="body-rander-item explain-home-info-input">
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.name"
                            required
                            name="name"
                            :border="false"
                            label="姓名"
                            placeholder="请输入报名人姓名"
                            :rules="[{ required: true, message: '请正确填写报名人姓名', validator: checkName }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.id"
                            required
                            maxlength="18"
                            name="id"
                            :border="false"
                            label="证件号"
                            placeholder="请输入报名人证件号"
                            :rules="[{ required: true, message: '请正确填写报名人证件号', validator: checkId }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.phone"
                            required
                            type="tel"
                            maxlength="11"
                            name="phone"
                            :border="false"
                            label="手机号码"
                            placeholder="请输入报名人手机号码"
                            :rules="[{ required: true, message: '请正确填写报名人手机号码', validator: checkPhone }]"
                        />
                    </li>
                    <!-- <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.identity"
                            required
                            name="identity"
                            :border="false"
                            label="社会身份"
                            placeholder="请输入报名人社会身份"
                            :rules="[{ required: true, message: '请正确填写报名人社会身份', validator: checkName }]"
                        />
                    </li> -->

                </ul>


                <ul class="body-rander-item explain-home-info-input">
                    <li class="row-box hide-input interest-box f-s-b">
                        <van-field
                            class="item-row f-s-b interest-left"
                            :border="false"
                            required
                            label="身份"
                            :rules="[{ required: false }]"
                        />
                        <div class="control-btn type-box ">
                            <div 
                                v-touch:tap="onchangeItem('identityActive',item.id)"
                                v-for="(item, index) in identityList" :key="index"
                                class="btn-box f-c"
                            >
                                <i class="iconhebei quan-size" :class="item.id === identityActive ? 'iconxuanzhong theme-color-font':'iconweixuanzhong'" ></i>
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </li>
                </ul>

                <ul class="body-rander-item explain-home-info-input">
                    <li class="row-box hide-input interest-box f-s-b">
                        <van-field
                            class="item-row f-s-b interest-left"
                            :border="false"
                            required
                            label="类型"
                            :rules="[{ required: false }]"
                        />
                        <div class="control-btn type-box ">
                            <div 
                                v-touch:tap="onchangeItem('typeActive',item.id)"
                                v-for="(item, index) in typeList" :key="index"
                                class="btn-box f-c"
                            >
                                <i class="iconhebei quan-size" :class="item.id === typeActive ? 'iconxuanzhong theme-color-font':'iconweixuanzhong'" ></i>
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </li>
                </ul>

                <ul class="body-rander-item explain-home-info-input">
                    <li class="row-box hide-input interest-box f-s-b">
                        <van-field
                            class="item-row f-s-b interest-left"
                            :border="false"
                            required
                            label="兴趣方向"
                            :rules="[{ required: false }]"
                        />
                        <div class="control-btn type-box ">
                            <div 
                                v-touch:tap="onchangeType(item)"
                                v-for="(item, index) in interestList" :key="index"
                                class="btn-box f-c"
                            >
                                <i class="iconhebei quan-size" :class="item.flag ? 'iconxuanzhong theme-color-font':'iconweixuanzhong'" ></i>
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </li>
                </ul>


            </div>

            <div class="foot f-c">
                <van-button class="btn f-c" block type="info" native-type="submit">
                    提交申请
                </van-button>
            </div>

            <div hidden style="width:0;height:0;">{{getUserInfo}}</div>


        </div>

    </van-form>

</template>

<script>
    import util from '@util';
    import { 
        Field,
        Form, 
        Button,
    } from 'vant';
    import {
        saveVolunTeerUrl,
    } from '@js/volunteerUrl.js';
    import {
        getUserInfoByOpenId,
    } from '@url';
    import http from '@js/http-zyz.js'
    export default {
        data() {
            return {
                phonePattern: /^1[3456789]\d{9}$/,
                idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                contactsInfo: {
                    name: '',
                    id: '',
                    phone: '',
                    // name: '测试人员',
                    // id: '510109198712211234',
                    // phone: '15928176933',
                    // identity: '',
                },
                typeActive: 0,
                typeList:[
                    {name:'全职',id:0},
                    {name:'兼职',id:1},
                ],
                identityActive: 0,
                identityList:[
                    {name:'学生',id:0},
                    {name:'教师',id:1},
                ],
                interestList:[
                    {
                        name:'全部',
                        id:0,
                        flag: !false,
                    },
                    {
                        name:'安保',
                        id:1,
                        flag: false,
                    },
                    {
                        name:'讲解',
                        id:2,
                        flag: false,
                    },
                    {
                        name:'公共服务',
                        id:3,
                        flag: false,
                    },
                    {
                        name:'其他',
                        id:4,
                        flag: false,
                    },
                ],
            }
        },
        methods: {
            onSubmit(values) {
                if(values) {
                    var interestArray = [];
                    var array = this.interestList;
                    for (let index = 0, len = array.length; index < len; index++) {
                        let element = array[index];
                        if(element.id === 0 && element.flag){
                            array.map(item=>{
                                if(item.id !== 0){
                                    interestArray.push(item.id);
                                }
                            })
                            break;
                        }else if(element.flag){
                            interestArray.push(element.id);
                        }
                    }
                    var data = {
                        userName: this.contactsInfo.name,
                        idcard: this.contactsInfo.id,
                        phone: this.contactsInfo.phone,
                        identity: this.identityActive,
                        workType: this.typeActive,
                        interest: interestArray.join(','),
                    }
                    if(interestArray.length > 0){
                        this.commit(data)
                    }
                }
            },
            commit(data){
                http.post(saveVolunTeerUrl, data)
                    .then(res=>{
                        var {
                            data: {
                                data: {
                                    volunteerApplyId
                                },
                                success,
                                msg
                            }
                        } = res;
                        if(success){
                            getUserInfoByOpenId(this.getOpenId);
                            this.$router.push({ name: 'applyVolunteerSuccess', query: { volunteerApplyId }});
                        }else{
                            this.$dialog({ message: msg });
                        }
                    })
            },
            checkName(v){
                return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v)
                // return v === ""? false : true;
            },
            onChangeNumber(type = 'narratorNumber',flag = true){
                return ()=>{
                    if(flag){
                        this[type]++
                    }else{
                        if(this[type]>1) {
                            this[type]--;
                        }
                    }
                }
            },
            checkPhone(v){
                return this.phonePattern.test(v)
                // return new Promise(resolve => {
                //     this.$toast.loading({
                //         forbidClick: true,
                //         message: '验证中...'
                //     });
                //     setTimeout(() => {
                //         this.$toast.clear();
                //         resolve(this.phonePattern.test(v));
                //     }, 700);
                // });
            },
            checkId(v){
                return this.idPattern.test(v);
            },
            onchangeItem(active,id){
                return ()=>{
                    this[active] = id;
                }
            },
            onchangeType(item){
                return ()=>{
                    item.flag = !item.flag;
                    if(item.id === 0){
                        this.interestList.map(inner=>{
                            inner.flag = item.flag;
                        })
                    }
                    var array = this.interestList;
                    var flag = true;
                    for (let index = 0, len = array.length; index < len; index++) {
                        let obj = array[index];
                        if(obj.id === 0){
                            continue;
                        }
                        if(!obj.flag){
                            flag = false;
                            break;
                        }
                    }
                    if(flag){
                        array[0].flag = true;
                    }else{
                        array[0].flag = false;
                    }
                }
            },
        },      
        computed: {
            getOpenId(){
                return this.$store.state.userInfo.openId || ''
            },
            getUserInfo(){
                var info = this.$store.state.userInfo.info || false;
                if(info){
                    this.contactsInfo.name = info.userName;
                    this.contactsInfo.phone = info.phone;
                    this.contactsInfo.id = info.idcard;
                }
                return info;
            },
        },
        components:{
            [Field.name]: Field,
            [Form.name]: Form,
            [Button.name]: Button,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        // height: ~"calc(100% - 50px)" !important;
        // padding-bottom: 50px;
        .header{
            position: relative;
            padding: 0 15px;
            box-sizing: border-box;
            background-color: #ffffff;
            height: 56px;
            color: #9C9C9C;
            .header-item{
                font-size: 13px;
                width: auto;
                position: relative;
                text-align: center;
            }
            .item-line{
                flex: 1;
                margin: 0 5px;
                width: auto;
                border-bottom: 1px dotted #9C9C9C;
            }
            .header-item-active{
                // margin-left: -25px;
                &::before{
                    background-color: #4282FF;
                    content: '';
                    border-radius: 2px;
                    height: 5px;
                    width: 65px;
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }

        .body{
            margin-bottom: 10px;
            padding: 7px;
            .body-rander-item{
                background-color: #ffffff;
                overflow: hidden;
                border-radius:5px;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                margin-bottom: 7px;
                .row-box{
                    position: relative;
                    box-sizing: border-box;
                    height: 50px;
                    padding: 0 12px;
                    background-color: #ffffff;
                    &:last-child{
                        .item-row{
                            border: 0;
                        }
                    }
                    .item-row{
                        border-bottom: .5px solid #CBCBCB;
                        height: 100%;
                        background-color: transparent;
                        font-size: 14px;
                    }
                    .right-control{
                        color: #9599A2;
                        position: absolute;
                        top: 50%;
                        overflow: hidden;
                        transform: translateY(-50%);
                        left: 90px;
                        right: 12px;
                        .icon-size{
                            &::before{
                                font-weight: 500;
                            }
                        }
                    }
                    .number-control{
                        justify-content: flex-start;
                        .number-box{
                            margin: 0 10px;
                            display: inline-flex;
                            vertical-align: top;
                            width:65px;
                            height:22px;
                            box-sizing: border-box;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .number-icon-size{
                            &::before{
                                font-size: 20px;
                                font-weight: 500;
                            }
                        }
                    }
                    .control-btn{
                        width: 100%;
                        .number-box{
                            margin: 0 6px;
                            width: 24px;
                            height: 24px;
                            font-size: 14px;
                            display: inline-flex;
                            justify-content: center;
                            align-items: center;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .icon-size{
                            &::before{
                                font-size: 22px;
                            }
                        }
                    }
                    .type-box{
                        padding-left: 1px;
                        transform: translateY(1px);
                        overflow: hidden;
                        justify-content: flex-start;
                        margin-top: -15px;
                        .btn-box{
                            color: #666666;
                            height: 20px;
                            margin-top: 15px;
                            font-size: 14px;
                            width: 84px;
                            float: left;
                            text-align: left;
                            vertical-align: top;
                            justify-content: flex-start;
                            .quan-size{
                                transition: all .3s ease;
                                margin-right: 5px;
                            }
                        }
                    }
                }
                .interest-box{
                    align-items: flex-start;
                    height: auto;
                    padding-top: 15px;
                    padding-bottom: 15px;
                    .interest-left{
                        width: 90px;
                    }
                }
                .info-row{
                    padding-top: 10px;
                    padding-bottom: 10px;
                    align-items: baseline;
                    height: auto;
                    justify-content: flex-start;
                    font-size: 12px;
                    color: #979899;
                    .left-txt{
                        margin-left: 12px;
                        width: 80px;
                        text-align-last: justify;
                        color: #61666C;
                        font-weight: 500;
                    }
                    .right-txt{
                        width: ~"calc(100% - 85px)";
                    }
                }
                .info-title{
                    padding-left: 0;
                    padding-right: 0;
                    margin: 0 12px;
                    border-bottom: .5px solid #CCCCCC;

                    align-items: baseline;
                    justify-content: space-between;
                    .inner-row{
                        align-items: baseline;
                    }
                    .info-left{
                        max-width: ~"calc(100% - 120px)";
                        font-size:14px;
                        font-weight:500;
                        color:rgba(67,68,70,1);
                        .icon-size{
                            margin-right: 10px;
                            height: 20px;
                            box-sizing:border-box; 
                            &::before{
                                font-size: 20px;
                                display: inline-block;
                                vertical-align: top;
                            }
                        }
                    }
                    .info-right{
                        font-size: 14px;
                        display: block;
                        max-width: 130px;
                        .count{
                            font-size: 17px;
                            margin-left: 3px;
                        }
                    }
                }
            }
            .body-container{
                position: relative;
                border-radius:5px;
                overflow: hidden;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                background-size: 118px 142px;
                background-repeat: no-repeat;
                background-position: right 70%;
                background-image: url('../../lib/image/home/567.png');
                background-color:rgba(255,255,255,1);
                box-sizing: border-box;
                width: 100%;
                padding: 14px 30px;
                font-size: 12px;
                color: #565656;
                height: auto;
                &{
                    .item:last-child{
                        margin: 0;
                    }
                }
                .title{
                    text-align: center;
                    color: #242424;
                    font-size: 16px;
                }
                .small-title{
                    font-size: 14px;
                    color: #565656;
                }
                .body-iamge{
                    width: 100%;
                    margin: 10px 0;
                }
                .item{
                    margin-bottom: 10px;
                }
                .time{
                    padding-left: 9px;
                    letter-spacing: 1px;
                }
            }
            .contacts-title-box{
                padding-left: 12px;
                height: 50px;
                font-size: 14px;
                color: #555555;
                // justify-content: flex-start;
                .icon-size{
                    margin-right: 5px;
                    &::before{  
                        font-size: 20px;
                    }
                }
                .look-narrators{
                    border: 0;
                    padding: 3px 6px;
                    font-size: 15px;
                    color:rgba(255,255,255,1);
                    background:rgba(92,162,253,1);
                    border-radius:3px;
                }
            }
        }

        .foot{
            background-color: #f0f1f4;
            // position: fixed;
            // bottom: 0;
            // left: 0;
            // right: 0;
            height: 50px;
            .btn{
                border: 0;
                font-size: 15px;
                color:rgba(255,255,255,1);
                width:332px;
                height:50px;
                background:rgba(92,162,253,1);
                border-radius:12px;
            }
        }

        .language-box{
            box-sizing: border-box;
            padding: 50px;
            flex-direction: column;
            .language{
                width: 100%;
            }
            .language-row{
                width: 100%;
                height: 40px;
            }
        }
    }
</style>